"use client";
import Container from "@/components-shared/container";
import { H1 } from "@/components-shared/headers";
import { RootState } from "@/redux/store";
import React from "react";
import { useSelector } from "react-redux";
import heroImage from "@/public/images/units.svg";
import { useTranslations } from "next-intl";
import Image from "next/image";

const HeroSection = ({
  description,
  title,
  noUser = false,
}: {
  description?: string;
  title?: string;
  noUser?: boolean;
}) => {
  const user = useSelector((state: RootState) => state.user);
  const t = useTranslations();
  return (
    <Container className="text-white relative z-10 pt-[100px] sm:h-[480px] h-72">
      <Image
        src={heroImage}
        alt="Hero Background"
        fill
        className="object-cover object-bottom -z-[1]"
        priority
      />
      <H1>
        {noUser
          ? t("heroSection.welcome_no_user", { title: title || "" })
          : t("heroSection.welcome", {
              name: user?.firstName || "",
              title: title || "",
            })}
      </H1>
      <h2 className="mt-8 lg:text-2xl lg:leading-[51.2px] md:text-xl text-sm leading-[25.6px] text-justify">
        {description}
      </h2>
    </Container>
  );
};

export default HeroSection;
